import StatusHandler from 'app/shared-components/StatusHandler'
import GatewayRequests from 'app/requests/Gateway/Gateway.requests'
import useGetGateway from 'app/requests/Gateway/hooks/useGetGateway'

import GatewayForm from '../GatewayForm'

const GatewayUpdate = ({
    id,
    disabled = false,
}: Readonly<{
    id: number,
    disabled?: boolean,
}>) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        invalidate,
        error,
    } = useGetGateway(id)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <GatewayForm
                data={data}
                onSuccess={invalidate}
                onCancel={invalidate}
                requestParam={GatewayRequests.update()}
                disabled={disabled}
            />
        </StatusHandler>

    )
}

export default GatewayUpdate
